import React from 'react';
import PatientSummarySearch from '../../components/history/modals/PetientSummarySearch';
import { List, Typography } from '@mui/material';

const MedicalHistoryPage = () => {

    return (
      <>
        <Typography variant="h4">Medical History</Typography>
        <List>
            <PatientSummarySearch autoOpen={true} />
        </List>
    </>
    );
};

export default MedicalHistoryPage;
